import './modules/lazy';
import './modules/header'
import './modules/slider'
import './modules/lottie-animation'
import './modules/scroll-anim'
import './modules/video'
import './modules/anchor-scroll'
import './modules/hero'